import type { BaseSyntheticEvent } from 'react';

export const enum StopPropagationEnum {
    'DEFAULT_ID' = 'clickIgnoreID',
}

export const stopPropagationHelper = ({ event, idForCheck }: { event: BaseSyntheticEvent; idForCheck?: string }) => {
    const id = idForCheck || StopPropagationEnum.DEFAULT_ID;

    return event?.target?.closest(`#${id}`);
};
